var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"posts"}},[_c('app-navbar'),_vm._v(" "),_c('main',{attrs:{"id":"main","role":"main"}},[_c('section',{staticClass:"two columns full-height"},[_c('app-sidebar')],1),_vm._v(" "),_c('section',{staticClass:"side-content columns full-height"},[_c('post-list')],1),_vm._v(" "),_c('section',{staticClass:"main-content columns full-height"},[_c('post-view')],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcf41b98","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Posts.vue
// module id = null
// module chunks = 